import { relicIcon } from '@/views/item/data'

export const debuffCollection: Record<number, { name: string; desc: (level: number) => string }> = {
  101: {
    name: '麻痹',
    desc: (level: number) => `受到${relicIcon.wind}风属性伤害增加<span class="grow">${(5 * level).toFixed(0)}%</span>`,
  },
  102: {
    name: '灼烧',
    desc: (level: number) => `受到${relicIcon.fire}火属性伤害增加<span class="grow">${(5 * level).toFixed(0)}%</span>`,
  },
  103: {
    name: '冰冻',
    desc: (level: number) => `受到${relicIcon.water}水属性伤害增加<span class="grow">${(5 * level).toFixed(0)}%</span>`,
  },
  104: {
    name: '石化',
    desc: (level: number) => `受到${relicIcon.soil}土属性伤害增加<span class="grow">${(5 * level).toFixed(0)}%</span>`,
  },
}
